import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type { PostConversationalPreviewRoutingProps } from "./types";

export const postConversationalPreviewRouting = reactQueryMutationAdapter(
  [],
  (props: PostConversationalPreviewRoutingProps): Promise<{}> => {
    return fetch(`/${props.appGroupId}/conversational/preview_routing`, "POST", {
      session_id: props.sessionId,
      user_message: props.userMessage,
      conversational_routing_setting: props.conversationalRoutingSetting,
    });
  }
);
